import { iFixitHotSpotItem } from './iFixitHotSpotItem';
import { HotSpot as HotSpotType } from 'Guide/Schematics/Diagram/Providers/dataContext';
import { TooltipContext } from '../Providers/tooltipContext';
import { KeyboardEventHandler, useCallback, useContext } from 'react';
import HotspotTooltip from '../UI/hotspotTooltip';
import { withOrderContext } from '../Providers/orderContext';
import { BasicHotspot } from 'Guide/Schematics/Diagram/Generic/basicHotspot';
import { useToken } from '@chakra-ui/react';

export const HotSpot = withOrderContext(function HotSpotInternal({
   hotspot,
}: {
   hotspot: HotSpotType<iFixitHotSpotItem>;
}) {
   const tooltipContext = useContext(TooltipContext);
   const [hotspotInner, hotspotOuter] = useToken('colors', ['hotspotInner', 'hotspotOuter']);
   const showTooltip = tooltipContext.openDataPointId == hotspot.id;

   const togglePoint = useCallback(() => {
      const isOpen = tooltipContext.openDataPointId == hotspot.id;
      if (isOpen) {
         tooltipContext.setOpenDataPointId(null);
      } else {
         tooltipContext.setOpenDataPointId(hotspot.id);
      }
   }, [tooltipContext.openDataPointId, hotspot.id]);

   const onKeyDown = useCallback<KeyboardEventHandler<SVGGElement>>(
      event => {
         if (event.key === 'Enter') {
            togglePoint();
         }
      },
      [togglePoint]
   );

   return (
      <HotspotTooltip data={hotspot} visible={showTooltip}>
         <BasicHotspot
            groupProps={{
               tabIndex: hotspot.tabIndex,
               onKeyDown: onKeyDown,
               onClick: togglePoint,
               focusable: true,
               cursor: 'pointer',
               _focus: {
                  outline: 'none',
               },
               role: 'group',
            }}
            innerCircleProps={{
               fill: hotspotInner,
               _groupHover: {
                  fill: hotspotOuter,
               },
               _groupFocus: {
                  fill: hotspotOuter,
               },
            }}
            outerCircleProps={{
               fill: hotspotOuter,
               _groupHover: {
                  fill: hotspotInner,
               },
               _groupFocus: {
                  fill: hotspotInner,
               },
            }}
            // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
            x={hotspot.scaledX}
            // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
            y={hotspot.scaledY}
         />
      </HotspotTooltip>
   );
});
